import { useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { getEditorDraft } from '../../DaEditorWrapper/redux/selectors';
/** Returns the draft state for the given `editorId` */ export function useEditorDraftState(editorId) {
    return useSelector(partialRight(getEditorDraft, editorId));
}
